import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import Swal from "sweetalert2";
import {CareerService} from "../../../shared/services/career.service";

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
    contactForm: FormGroup;

    constructor(
        private contactService: CareerService,
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {
        window.scroll(0, 0);
        this.contactForm = this.formBuilder.group({
            'name': ['', Validators.required],
            'email': ['', Validators.required],
            'subject': [''],
            'message': [''],
            'contact': ['', Validators.required],
        });
    }

    submit() {
        const params = {
            'name': this.contactForm.value.name,
            'email': this.contactForm.value.email,
            'subject': this.contactForm.value.subject,
            'contact': this.contactForm.value.contact,
            'message': this.contactForm.value.message,
        };
        this.contactService.contact(params).subscribe(data => {
            this.showAlert();
            this.contactForm.reset();
        }, error => {
            console.log(error.error);
        });
    }

    showAlert() {
        Swal.fire({
            title: 'Your form Submitted!',
            text: 'We may contact you as soon as possible',
            icon: 'success',
            confirmButtonText: 'OK',
        });
    }

    showWarningAlert() {
        Swal.fire({
            title: 'Field Missing!',
            icon: 'info',
            html: 'All Fields are required!',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok!',
        });
    }

}
